(() => {
  const body = document.body;
  const drawer = document.querySelector('[data-cart-drawer]');
  const scrim = document.querySelector('.drawer-scrim');
  const selectedWeeks = document.querySelector('[data-selected-weeks]');
  let drawerReturnFocus = null;

  const drawerFocusable = () => drawer
    ? Array.from(drawer.querySelectorAll('button:not(:disabled), [href], input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex]:not([tabindex="-1"])'))
    : [];

  const setDrawer = (open, trigger = null) => {
    if (!drawer || !scrim) return;
    const wasOpen = drawer.classList.contains('visible');
    if (open === wasOpen) return;

    if (open) {
      drawerReturnFocus = trigger || document.activeElement;
      drawer.removeAttribute('inert');
      drawer.classList.add('visible');
      scrim.classList.add('visible');
      drawer.setAttribute('aria-hidden', 'false');
      body.style.overflow = 'hidden';
      window.requestAnimationFrame(() => {
        const first = drawerFocusable()[0];
        (first || drawer).focus();
      });
      return;
    }

    drawer.classList.toggle('visible', open);
    scrim.classList.toggle('visible', open);
    body.style.overflow = '';
    const focusTarget = drawerReturnFocus;
    drawerReturnFocus = null;
    if (focusTarget && document.contains(focusTarget)) focusTarget.focus();
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
  };

  document.querySelectorAll('[data-open-bag]').forEach((button) => button.addEventListener('click', () => {
    const bagCount = document.querySelector('[data-plan-bag-count]');
    if (button.closest('.site-header') && bagCount?.textContent?.trim() === '0') {
      document.querySelector('#plan')?.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'start'
      });
      return;
    }
    setDrawer(true, button);
  }));
  document.addEventListener('essenca:open-bag', (event) => setDrawer(true, event.detail?.trigger || null));
  document.querySelectorAll('[data-close-bag]').forEach((button) => button.addEventListener('click', () => setDrawer(false)));
  document.addEventListener('keydown', (event) => {
    if (!drawer?.classList.contains('visible')) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      setDrawer(false);
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = drawerFocusable();
    if (!focusable.length) {
      event.preventDefault();
      drawer.focus();
      return;
    }
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (!focusable.includes(document.activeElement)) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
    } else if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.querySelectorAll('[data-weeks]').forEach((button) => {
    button.addEventListener('click', () => {
      document.querySelectorAll('[data-weeks]').forEach((item) => item.classList.remove('selected'));
      button.classList.add('selected');
      if (selectedWeeks) selectedWeeks.textContent = button.dataset.weeks;
    });
  });

  /* ===== How it works — horizontal carousel (seamless loop) ===== */
  const howRoot = document.querySelector('[data-how-root]');
  if (howRoot) {
    const viewport = howRoot.querySelector('[data-how-viewport]');
    const slidesWrap = howRoot.querySelector('[data-how-slides]');
    const dotsWrap = howRoot.querySelector('[data-how-dots]');
    const prevBtn = howRoot.querySelector('[data-how-prev]');
    const nextBtn = howRoot.querySelector('[data-how-next]');
    const lightbox = howRoot.querySelector('[data-how-lightbox]');
    const lightboxImg = howRoot.querySelector('[data-how-lightbox-img]');

    const realSlides = Array.from(slidesWrap.querySelectorAll('.how-slide'));
    const total = realSlides.length;
    let pos = 1; // DOM index of the centered slide (1..total are real; 0 = lastClone, total+1 = firstClone)
    let autoTimer = 0;

    const dots = realSlides.map((slide, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'how-dot';
      dot.setAttribute('role', 'tab');
      dot.setAttribute('aria-label', `Step ${i + 1}`);
      dot.addEventListener('click', () => { pos = i + 1; render(pos, true); setDot(i); restartAuto(); });
      dotsWrap.appendChild(dot);
      return dot;
    });
    const setDot = (realIdx) => {
      const r = ((realIdx % total) + total) % total;
      dots.forEach((d, k) => {
        const active = k === r;
        d.classList.toggle('is-active', active);
        d.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    };

    /* seamless loop: clone last slide at front, first slide at end */
    const firstClone = realSlides[0].cloneNode(true);
    const lastClone = realSlides[total - 1].cloneNode(true);
    slidesWrap.appendChild(firstClone);
    slidesWrap.insertBefore(lastClone, realSlides[0]);
    const allSlides = Array.from(slidesWrap.children); // [lastClone, s0..sN-1, firstClone]

    const render = (domIdx, smooth) => {
      const el = allSlides[domIdx];
      if (!el) return;
      const target = el.offsetLeft - (viewport.clientWidth - el.clientWidth) / 2;
      viewport.scrollTo({ left: Math.max(0, target), behavior: smooth ? 'smooth' : 'auto' });
    };

    const nearestDom = () => {
      const center = viewport.scrollLeft + viewport.clientWidth / 2;
      let best = 0;
      let min = Infinity;
      allSlides.forEach((s, i) => {
        const c = s.offsetLeft + s.clientWidth / 2;
        const dist = Math.abs(c - center);
        if (dist < min) { min = dist; best = i; }
      });
      return best;
    };

    const realOfPos = (p) => {
      if (p === 0) return total - 1;        // lastClone
      if (p === total + 1) return 0;        // firstClone
      return p - 1;
    };

    const afterScroll = () => {
      if (pos === total + 1) { pos = 1; render(pos, false); }   // wrapped past last -> real first
      else if (pos === 0) { pos = total; render(pos, false); }   // wrapped before first -> real last
      setDot(realOfPos(pos));
    };
    let afterTimer = 0;
    const scheduleAfter = () => {
      if (afterTimer) clearTimeout(afterTimer);
      afterTimer = setTimeout(afterScroll, 560);
    };

    const goTo = (i, smooth = true) => {
      pos = i + 1;
      setDot(i);
      render(pos, smooth);
      if (smooth) scheduleAfter();
    };

    const goNext = () => {
      pos += 1;
      render(pos, true);
      if (pos === total + 1) scheduleAfter(); else setDot(realOfPos(pos));
      restartAuto();
    };

    const goPrev = () => {
      pos -= 1;
      render(pos, true);
      if (pos === 0) scheduleAfter(); else setDot(realOfPos(pos));
      restartAuto();
    };

    nextBtn.addEventListener('click', goNext);
    prevBtn.addEventListener('click', goPrev);

    /* drag / swipe */
    let down = false;
    let moved = false;
    let startX = 0;
    let startScroll = 0;
    viewport.addEventListener('pointerdown', (e) => {
      down = true; moved = false; startX = e.clientX; startScroll = viewport.scrollLeft;
      viewport.classList.add('is-dragging');
    });
    viewport.addEventListener('pointermove', (e) => {
      if (!down) return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 6) moved = true;
      viewport.scrollLeft = startScroll - dx;
    });
    const endDrag = () => {
      if (!down) return;
      down = false;
      viewport.classList.remove('is-dragging');
      pos = nearestDom();
      render(pos, false);
      afterScroll();
    };
    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);
    viewport.addEventListener('pointerleave', endDrag);

    /* live dot update while scrolling/dragging */
    let scrollTick = 0;
    viewport.addEventListener('scroll', () => {
      if (scrollTick) return;
      scrollTick = requestAnimationFrame(() => {
        scrollTick = 0;
        setDot(realOfPos(nearestDom()));
      });
    });

    /* correct clone position once a smooth scroll settles */
    if ('onscrollend' in window) viewport.addEventListener('scrollend', afterScroll);

    /* autoplay */
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const startAuto = () => {
      if (reducedMotion.matches) return;
      stopAuto();
      autoTimer = setInterval(goNext, 3000);
    };
    const stopAuto = () => { if (autoTimer) clearInterval(autoTimer); autoTimer = 0; };
    const restartAuto = () => { stopAuto(); startAuto(); };

    howRoot.addEventListener('pointerenter', stopAuto);
    howRoot.addEventListener('pointerleave', startAuto);
    howRoot.addEventListener('focusin', stopAuto);
    howRoot.addEventListener('focusout', startAuto);
    document.addEventListener('visibilitychange', () => { if (document.hidden) stopAuto(); else startAuto(); });

    /* lightbox — Learn more zooms the image (delegated, works on clones too) */
    howRoot.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-how-zoom]');
      if (!btn) return;
      if (moved) { moved = false; return; }
      e.stopPropagation();
      const slide = btn.closest('[data-how-slide]');
      lightboxImg.src = slide.dataset.img;
      lightboxImg.alt = slide.dataset.alt || '';
      stopAuto();
      if (typeof lightbox.showModal === 'function') lightbox.showModal();
    });
    const closeLightbox = () => { if (lightbox.open) lightbox.close(); };
    lightbox.addEventListener('click', (e) => { if (e.target === lightbox || e.target.closest('.how-lightbox-close')) closeLightbox(); });
    lightbox.addEventListener('cancel', (e) => { e.preventDefault(); closeLightbox(); });

    goTo(0, false);
    startAuto();
    window.addEventListener('resize', () => { render(pos, false); });
  }

  const sectionLinks = Array.from(document.querySelectorAll('.site-header nav a[href^="#"]'));
  const sectionTargets = sectionLinks
    .map((link) => document.querySelector(link.getAttribute('href')))
    .filter(Boolean);
  const setCurrentSection = (section) => {
    sectionLinks.forEach((link) => {
      const current = section && link.getAttribute('href') === `#${section.id}`;
      if (current) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
  };
  sectionLinks.forEach((link) => link.addEventListener('click', () => {
    setCurrentSection(document.querySelector(link.getAttribute('href')));
  }));
  if ('IntersectionObserver' in window && sectionTargets.length) {
    const sectionObserver = new IntersectionObserver(() => {
      const marker = (document.querySelector('.site-header')?.offsetHeight || 58) + window.innerHeight * .2;
      const current = sectionTargets.find((section) => {
        const rect = section.getBoundingClientRect();
        return rect.top <= marker && rect.bottom > marker;
      });
      setCurrentSection(current || null);
    }, { rootMargin: '-18% 0px -66% 0px', threshold: [0, .1, .35] });
    sectionTargets.forEach((section) => sectionObserver.observe(section));
  }

  const optimizeCreatorCovers = () => {
    const requestedWidth = window.matchMedia('(max-width: 749px)').matches ? '240x' : '320x';
    document.querySelectorAll('.creator-card img').forEach((image) => {
      const source = image.currentSrc || image.src;
      if (!source || /_\d+x\.webp(?:\?|$)/.test(source)) return;
      const optimized = source.replace(/\.webp(?=\?|$)/, `_${requestedWidth}.webp`);
      image.src = optimized;
      image.fetchPriority = 'low';
      const card = image.closest('.creator-card');
      if (card) card.dataset.image = optimized;
    });
  };

  optimizeCreatorCovers();

  const openVideo = (card) => {
    const poster = card.dataset.poster || card.dataset.image;
    const row = card.closest('.creator-row');
    const rowIndex = row ? Array.from(document.querySelectorAll('.creator-row')).indexOf(row) : 0;
    const cardIndex = row ? Array.from(row.querySelectorAll('.creator-card')).indexOf(card) % 5 : 0;
    const rowHandles = [
      ['@sofiaramsay', '@shop.lex.finds', '@brooktheshopaholic', '@masvir.go2', '@gina.ruhnay'],
      ['@younghomefinds', '@sofiaramsay', '@chloewhite4971', '@jenuinefinds', '@stylebybrimarie']
    ];
    const rowIds = [
      ['7639915266788379918', '7652070701356043551', '7646982486198668575', '7640204262911331598', '7647507711420157214'],
      ['7648921608966376734', '7639915266788379918', '7626204531436604703', '7648812818904485151', '7645322183438355726']
    ];
    const hostedVideos = [
      [
        'https://cdn.shopify.com/videos/c/vp/a2a540c7c2154be7a55b7d1416a8b27b/a2a540c7c2154be7a55b7d1416a8b27b.HD-1080p-2.5Mbps-93276050.mp4',
        'https://cdn.shopify.com/videos/c/vp/e69c0f8bfd294973b6b8789af06d2e32/e69c0f8bfd294973b6b8789af06d2e32.HD-1080p-2.5Mbps-93276049.mp4',
        'https://cdn.shopify.com/videos/c/vp/60c8d829e7e0460a85497c6df33e41d8/60c8d829e7e0460a85497c6df33e41d8.HD-1080p-2.5Mbps-93276044.mp4',
        'https://cdn.shopify.com/videos/c/vp/1cba1c5e22ec4987b11d4e0e5c5d023b/1cba1c5e22ec4987b11d4e0e5c5d023b.HD-1080p-2.5Mbps-93276048.mp4',
        'https://cdn.shopify.com/videos/c/vp/e18d2d4eab774b26858fa951f889d7f7/e18d2d4eab774b26858fa951f889d7f7.HD-1080p-2.5Mbps-93276046.mp4'
      ],
      [
        'https://cdn.shopify.com/videos/c/vp/3fa71fca98aa4719bf7dd75fb43a20d3/3fa71fca98aa4719bf7dd75fb43a20d3.HD-1080p-2.5Mbps-93276052.mp4',
        'https://cdn.shopify.com/videos/c/vp/a2a540c7c2154be7a55b7d1416a8b27b/a2a540c7c2154be7a55b7d1416a8b27b.HD-1080p-2.5Mbps-93276050.mp4',
        'https://cdn.shopify.com/videos/c/vp/38a1d9fe2a344e5483c5fd9d30745a67/38a1d9fe2a344e5483c5fd9d30745a67.HD-1080p-2.5Mbps-93276045.mp4',
        'https://cdn.shopify.com/videos/c/vp/31119be628e846da8f34a67fb547ffbb/31119be628e846da8f34a67fb547ffbb.HD-1080p-2.5Mbps-93276047.mp4',
        'https://cdn.shopify.com/videos/c/vp/5152f94c1b824356ad336a9efdf35b00/5152f94c1b824356ad336a9efdf35b00.HD-1080p-2.5Mbps-93276051.mp4'
      ]
    ];
    const handle = rowHandles[rowIndex]?.[cardIndex] || card.dataset.handle || '';
    const tiktokId = card.dataset.tiktokId || rowIds[rowIndex]?.[cardIndex];
    const video = hostedVideos[rowIndex]?.[cardIndex] || card.dataset.video;
    const modal = document.createElement('dialog');
    modal.className = 'video-modal';
    modal.setAttribute('aria-label', 'Essénca creator story');
    const loadingIndicator = video || tiktokId
      ? '<div class="video-loading" role="status"><span aria-hidden="true"></span>Loading creator video…</div>'
      : '';
    const frame = video
      ? `<video class="video-frame video-frame--hosted" src="${video}" poster="${poster}" controls autoplay playsinline preload="metadata"></video>`
      : tiktokId
      ? `<iframe class="video-frame video-frame--tiktok" src="https://www.tiktok.com/player/v1/${tiktokId}?autoplay=1&description=0&music_info=1" title="TikTok video by ${handle}" allow="autoplay; encrypted-media; fullscreen" allowfullscreen loading="eager" referrerpolicy="strict-origin-when-cross-origin"></iframe>`
      : `<img class="video-frame" src="${poster}" alt="Essénca creator video cover">`;
    modal.innerHTML = `<div class="video-card">${loadingIndicator}${frame}${handle ? `<small>${handle}</small>` : ''}<button type="button" aria-label="Close creator story">×</button></div>`;
    const tiktokFrame = modal.querySelector('.video-frame--tiktok');
    tiktokFrame?.addEventListener('load', () => modal.classList.add('is-loaded'), { once: true });
    const hostedPlayer = modal.querySelector('.video-frame--hosted');
    hostedPlayer?.addEventListener('loadeddata', () => modal.classList.add('is-loaded'), { once: true });
    hostedPlayer?.addEventListener('error', () => modal.classList.add('is-loaded'), { once: true });
    const close = () => {
      if (!modal.open) return;
      const v = modal.querySelector('video');
      if (v) { try { v.pause(); } catch (e) {} v.removeAttribute('src'); v.load(); }
      modal.close();
    };
    modal.addEventListener('click', (event) => { if (event.target === modal || event.target.closest('button')) close(); });
    modal.addEventListener('cancel', (event) => { event.preventDefault(); close(); });
    modal.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(); });
    modal.addEventListener('close', () => { modal.remove(); body.style.overflow = ''; }, { once: true });
    body.appendChild(modal);
    body.style.overflow = 'hidden';
    modal.showModal();
    if (hostedPlayer) {
      hostedPlayer.muted = false;
      hostedPlayer.volume = 1;
      hostedPlayer.play().catch(() => {});
    }
    modal.querySelector('button')?.focus();
  };

  document.querySelectorAll('.creator-row').forEach((row, rowIndex) => {
    let down = false;
    let moved = false;
    let startX = 0;
    let startY = 0;
    let startScroll = 0;
    let lastTime = performance.now();
    const cards = row.querySelectorAll('.creator-card');
    const loopWidth = () => cards.length > 5
      ? cards[5].offsetLeft - cards[0].offsetLeft
      : row.scrollWidth / 3;

    if (rowIndex % 2 === 1) row.scrollLeft = loopWidth();

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let animationFrame = 0;
    const tick = (now) => {
      if (!down) {
        const delta = Math.min(now - lastTime, 50) * 0.035;
        const width = loopWidth();
        row.scrollLeft += rowIndex % 2 === 0 ? delta : -delta;
        /* Browsers clamp scrollLeft at max; use the real edge so the first row
           cannot freeze one pixel short of the old width * 2 threshold. */
        const maxScroll = row.scrollWidth - row.clientWidth;
        if (rowIndex % 2 === 0 && row.scrollLeft >= maxScroll - 1) row.scrollLeft -= width;
        if (row.scrollLeft <= 0) row.scrollLeft += width;
      }
      lastTime = now;
      animationFrame = requestAnimationFrame(tick);
    };

    const syncAnimation = () => {
      if (animationFrame) cancelAnimationFrame(animationFrame);
      animationFrame = 0;
      if (document.hidden || reducedMotion.matches) return;
      lastTime = performance.now();
      animationFrame = requestAnimationFrame(tick);
    };

    syncAnimation();
    document.addEventListener('visibilitychange', syncAnimation);
    reducedMotion.addEventListener('change', syncAnimation);
    row.addEventListener('pointerdown', (event) => { down = true; moved = false; startX = event.clientX; startY = event.clientY; startScroll = row.scrollLeft; });
    row.addEventListener('pointermove', (event) => { if (!down) return; const dx = event.clientX - startX; const dy = event.clientY - startY; if (Math.abs(dx) > 6 || Math.abs(dy) > 6) moved = true; row.scrollLeft = startScroll - dx; });
    row.addEventListener('pointerup', () => { down = false; });
    row.addEventListener('pointercancel', () => { down = false; });
    row.addEventListener('click', (event) => {
      if (moved) return;
      const card = event.target.closest('.creator-card');
      if (!card) return;
      openVideo(card);
    });
  });

  const productGallery = document.querySelector('[data-product-gallery]');
  if (productGallery) {
    const mainImage = productGallery.querySelector('[data-product-gallery-main]');
    const thumbnails = Array.from(productGallery.querySelectorAll('[data-product-gallery-thumb]'));
    const galleryReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let galleryRequest = 0;

    const selectGalleryImage = async (button) => {
      if (!mainImage || !button?.dataset.src) return;
      const requestId = ++galleryRequest;
      for (const thumbnail of thumbnails) {
        const selected = thumbnail === button;
        thumbnail.classList.toggle('is-active', selected);
        thumbnail.setAttribute('aria-pressed', String(selected));
      }

      mainImage.classList.add('is-changing');
      mainImage.src = button.dataset.src;
      mainImage.alt = button.dataset.alt || '';
      mainImage.width = Number(button.dataset.width) || mainImage.width;
      mainImage.height = Number(button.dataset.height) || mainImage.height;
      try {
        await mainImage.decode();
      } catch (error) {
        // The browser still displays the image if decode() is unavailable or interrupted.
      } finally {
        if (requestId === galleryRequest) mainImage.classList.remove('is-changing');
      }
      button.scrollIntoView({
        behavior: galleryReducedMotion.matches ? 'auto' : 'smooth',
        block: 'nearest',
        inline: 'nearest',
      });
    };

    for (const [index, button] of thumbnails.entries()) {
      button.addEventListener('click', () => selectGalleryImage(button));
      button.addEventListener('pointerenter', () => {
        const preloadImage = new Image();
        preloadImage.src = button.dataset.src;
      }, { once: true });
      button.addEventListener('keydown', (event) => {
        const keyTargets = {
          ArrowLeft: index - 1,
          ArrowRight: index + 1,
          Home: 0,
          End: thumbnails.length - 1,
        };
        if (!(event.key in keyTargets)) return;
        event.preventDefault();
        const targetIndex = (keyTargets[event.key] + thumbnails.length) % thumbnails.length;
        const target = thumbnails[targetIndex];
        target.focus();
        selectGalleryImage(target);
      });
    }
  }

  const contactForm = document.querySelector('#EssencaContactForm');
  if (contactForm) {
    const successMessage = contactForm.querySelector('[data-contact-success]');
    if (successMessage) window.requestAnimationFrame(() => successMessage.focus());
    contactForm.addEventListener('submit', () => {
      if (!contactForm.checkValidity()) return;
      const submitButton = contactForm.querySelector('[type="submit"]');
      if (!submitButton) return;
      submitButton.disabled = true;
      submitButton.setAttribute('aria-busy', 'true');
      if (submitButton.dataset.sendingLabel) submitButton.textContent = submitButton.dataset.sendingLabel;
    });
  }
})();
